import i18next from 'i18next';
import { KnownError } from './KnownError';

export class DocumentNotFoundError extends KnownError {
  constructor(message?: string) {
    super(
      message ?? i18next.t('translation:patients.documents.document_not_found'),
    );
  }
}
